<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";

export default {
  data() {
    return {
      opportunity: null,
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },

  components: {
    Jobs,
    SearchJob,
  },
};
</script>

<template>
  <div class="collection">
    <div class="container">
      <h1>sobre a LE LIS BLANC</h1>
      <p>
   A primeira marca da Restoque é sinônimo de um lifestyle repleto de felicidade, desejo, estilo e versatilidade. A Le Lis Blanc está sempre conectada com as tendências, oferecendo roupas para todas as ocasiões – do trabalho, com a alfaiataria bem cortada, aos looks de festa –, além da sua linha Petit e Le Lis Casa.

Com mais de 80 lojas espalhadas pelo Brasil e presença intensa nas principais multimarcas físicas e virtuais, a Le Lis conta também com canais de venda on-line, que oferecem diferentes experiências de compras, alinhadas com o momento e necessidade de nossas clientes.
      </p>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.collection {
    margin-top: 4rem;
}
h1 {
    font-size: 1.9rem;
    text-transform: uppercase;
    font-weight: 500;
    color: #000;
}
p {
    font-size: 1.2rem;
    color: #000;
    margin-top: 1rem;
     border-bottom: 2px solid theme-color(primary);
     padding-bottom: 2rem;
     margin-bottom: 1.5rem;
}
</style>